export default __webpack_public_path__ + "static/media/333.1c2a2888.gif";